import { BeforeAfter } from "@/components/BeforeAfter";
import { assetUrl } from "@/lib/api";

export const OtherWays = ({ items, original }) => {
  if (!items?.length) return null;
  return (
    <section className="mt-10" data-testid="other-ways-section">
      <div className="eyebrow mb-1">Other ways to fix it</div>
      <p className="mb-4 max-w-xl text-xs text-[var(--stone-dark)]">Inspiration only. The current vision stays the plan; these options need extra cabinetry, electrical or venting work and a professional quote.</p>
      <div className="grid gap-6 md:grid-cols-3">
        {items.map((x) => (
          <article key={x.id} data-testid={`other-way-${x.key}`}>
            <BeforeAfter before={assetUrl(original.url)} after={assetUrl(x.afterUrl)} width={x.width || original.width} height={x.height || original.height} testid={`other-way-slider-${x.key}`} />
            <div className="mt-2 font-display text-lg leading-tight" data-testid={`other-way-title-${x.key}`}>{x.title}</div>
            <div className="mt-1 font-mono-ui text-[0.62rem] uppercase tracking-[0.08em] text-[var(--terracotta,#C4572E)]" data-testid={`other-way-label-${x.key}`}>{x.label}</div>
            {x.quoteLine && <div className="mt-1 text-xs text-[var(--stone-dark)]" data-testid={`other-way-quote-${x.key}`}>{x.quoteLine.name} · Quote required</div>}
          </article>
        ))}
      </div>
    </section>
  );
};
